var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"bin-manifest-page\">\n<h2>Deposit Reports Page</h2>\n</div>\n";
var id1="deposit_reports.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/branch_management/components/deposit_reports/deposit_reports.html
// module id = 2681
// module chunks = 1